export default __webpack_public_path__ + "static/media/ccstype2.9f55786f.png";